import { useState } from 'react';

const testimonials = [
  {
    id: 1,
    quote: '導入により不正検知率が40%向上し、年間の不正被害額を大幅に削減できました。リアルタイム監視の精度の高さに驚いています。',
    name: '山田 太郎',
    title: '某都市銀行 システム部長',
    rating: 4.9,
    image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Japanese%20businessman%20in%20his%2050s%2C%20wearing%20a%20navy%20suit%20and%20tie%2C%20clean%20white%20background%2C%20warm%20confident%20smile%2C%20corporate%20portrait%20style%2C%20soft%20studio%20lighting&width=120&height=120&seq=testimonial-yamada&orientation=squarish',
  },
  {
    id: 2,
    quote: 'API連携が非常にスムーズで、導入からわずか2週間でフル稼働を開始できました。技術サポートのレスポンスも素晴らしいです。',
    name: '田中 美咲',
    title: '某決済代行会社 CTO',
    rating: 4.8,
    image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Japanese%20businesswoman%20in%20her%2040s%2C%20wearing%20a%20dark%20blazer%2C%20clean%20white%20background%2C%20confident%20professional%20expression%2C%20corporate%20portrait%20style%2C%20soft%20studio%20lighting&width=120&height=120&seq=testimonial-tanaka&orientation=squarish',
  },
  {
    id: 3,
    quote: 'コンプライアンス対応が非常にしっかりしており、金融庁の監査でも安心して対応できました。信頼できるパートナーです。',
    name: '鈴木 一郎',
    title: '某地方銀行 リスク管理部長',
    rating: 5.0,
    image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Japanese%20businessman%20in%20his%2040s%2C%20wearing%20a%20gray%20suit%2C%20clean%20white%20background%2C%20friendly%20professional%20smile%2C%20corporate%20portrait%20style%2C%20soft%20studio%20lighting&width=120&height=120&seq=testimonial-suzuki&orientation=squarish',
  },
];

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));

  const t = testimonials[current];

  return (
    <section className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <h3 className="text-xl md:text-3xl font-heading font-light text-foreground-950 tracking-[0.08em]">
            &ldquo;お客様の声&rdquo;
          </h3>
        </div>

        {/* Quote Card */}
        <div className="max-w-3xl mx-auto relative">
          {/* Rating Tag */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-foreground-900 text-accent-400 mb-8">
            <i className="ri-star-fill text-sm text-accent-500" />
            <span className="text-sm tracking-[0.08em] font-sans font-medium">{t.rating}</span>
          </div>

          {/* Quote */}
          <blockquote className="text-lg md:text-xl lg:text-2xl text-foreground-800 tracking-[0.06em] leading-[1.8] font-heading font-light">
            &ldquo;{t.quote}&rdquo;
          </blockquote>

          {/* Author */}
          <div className="mt-10 flex items-center gap-4">
            <div className="w-14 h-14 md:w-16 md:h-16 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
              <img
                src={t.image}
                alt={t.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <p className="text-sm md:text-base text-foreground-950 tracking-[0.06em] font-sans font-medium">{t.name}</p>
              <p className="text-xs md:text-sm text-foreground-500 tracking-[0.05em] font-sans font-light">{t.title}</p>
            </div>
          </div>

          {/* Navigation Arrows */}
          <div className="absolute bottom-0 right-0 flex gap-3">
            <button
              onClick={prev}
              className="w-10 h-10 rounded-full border border-foreground-300 flex items-center justify-center hover:bg-foreground-50 hover:border-foreground-400 transition-all duration-300 cursor-pointer"
              aria-label="前のレビュー"
            >
              <i className="ri-arrow-left-line text-foreground-600" />
            </button>
            <button
              onClick={next}
              className="w-10 h-10 rounded-full bg-foreground-900 flex items-center justify-center hover:bg-foreground-800 transition-all duration-300 cursor-pointer"
              aria-label="次のレビュー"
            >
              <i className="ri-arrow-right-line text-accent-400" />
            </button>
          </div>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-10">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                i === current ? 'bg-foreground-800 w-6' : 'bg-foreground-300'
              }`}
              aria-label={`レビュー ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}